import { useState } from "react";
import PropTypes from "prop-types";
import { AsyncPaginate } from "react-select-async-paginate";
import { getTotalPages } from "../../utils/helpers/getTotalPages";
import { getEnvVariables } from "../../utils/helpers/getEnvVariables";
import { useNotifyHandler } from "@Hooks";

const SelectAsyncPaginateMunicipios = (props) => {
  const [itemsDonwload, setItemsDonwload] = useState({ results: [] });
  const { alertNotify } = useNotifyHandler();
  const { API_URL } = getEnvVariables();

  const getAllMunicipality = async () => {
    let municipalities = [];
    let page = 1;
    let lastPage = 999

    while (page <= lastPage) {
      if (!props.departamento) break

      const response = await fetch(`${API_URL}/utils/municipios/?departamento=${props.departamento}&page=${page}`);
      const responseData = await response.json();
      if (responseData?.results && lastPage === 999) {
        const totalItems = responseData.count
        const itemsPerPage = responseData?.results.length
        lastPage = getTotalPages(totalItems, itemsPerPage)
      }
      municipalities = municipalities.concat(responseData.results);
      page++;
    }
    return municipalities;
  };

  const getDefaultValue = async () => {
    const municipalities = await getAllMunicipality()
    const defaultValue = municipalities?.filter(item => item.id === props.idMun)[0]
    props.onChange(defaultValue)
  }

  const printAlert = () => {
    if (!props.departamento) {
      alertNotify(
        "Seleccionar un departamento primero",
        "bottom",
        "center",
        "error"
      );
    }
  };

  const loadOptions = async (searchQuery, loadedOptions, { page }) => {
    let resp = itemsDonwload;
    let nextHas = null;
    if (props.departamento && searchQuery.length == 0) {
      const response = await fetch(
        `${API_URL}/utils/municipios/?departamento=${props.departamento}&page=${page}`
      );
      resp = await response.json();
      setItemsDonwload({
        ...resp,
        results: [...resp.results, ...(itemsDonwload?.results || [])],
      });
      nextHas = resp.next;
    } else {
      resp = itemsDonwload;
    }
    return {
      options: resp.results,
      hasMore: nextHas !== null,
      additional: {
        page: searchQuery ? 2 : page + 1,
      },
    };
  };

  const onChange = (option) => {
    if (typeof props.onChange === "function") {
      props.onChange(option);
    }
  };

  return (
    <AsyncPaginate
      styles={props.styles}
      key={JSON.stringify(props.departamento)}
      value={props.value || getDefaultValue}
      loadOptions={loadOptions}
      getOptionValue={(option) => option.nombre}
      getOptionLabel={(option) => option.nombre}
      onChange={onChange}
      onFocus={printAlert}
      placeholder="Seleccionar"
      additional={{
        page: 1,
      }}
      isSearchable
      filterOption={(option, inputValue) =>
        option.label.toLowerCase().includes(inputValue.toLowerCase())
      }
    />
  );
};

SelectAsyncPaginateMunicipios.propTypes = {
  departamento: PropTypes.number,
  value: PropTypes.any,
  onChange: PropTypes.func,
};

export default SelectAsyncPaginateMunicipios;